<template>
  <div id="ُSanadRizNew" dir="rtl">
    <Card back>
      <template slot="header">
        <h3>سند حسابداری</h3>
        <hr />
      </template>
      <template slot="content">
        <!-- <button v-if="this.AccessBtn" class="btn btn-secondary d- mr-1" dir="ltr" data-toggle="collapse" @click.prevent="$ResetTimer()" data-target="#demo"><span class="mr-2">تنظیمات</span> <span class="fa fa-gear"></span></button> -->
        <!-- <button
          id="btnCancel"
          v-if="this.AccessBtn"
          class="btn btn-info-hover-reverse mr-1"
          dir="ltr"
          @click.prevent="
            Back()
            $ResetTimer()
          "
        >
          <span class="mr-2">بازگشت</span> <span class="fa fa-reply"></span>
        </button> -->
        <div id="demo" class="collapse">
          <div class="mt-2 mr-2">
            <div class="w-100 mb-2">
              <div class="card p-2">
                <div class="row">
                  <div class="col-md-3 col-12"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container w-100 pb-3 mt-2">
          <div class="row p-3">
            <div class="col-md-2 col-12">
              <small>شماره سند</small>
              <input type="text" placeholder="شماره سند موقت" disabled class="form-control" v-model="this.DataAxiosSanadRizNew.ArryfildValue.ShomareSanad" />
            </div>
            <div class="col-md-2 col-12">
              <small>دوره مالی </small>
              <SearchableCombo
                :edit="false"
                :grp="11"
                :defaultvalue="$session.get('DoreMaliData')[$session.get('DoreMaliData').length - 1].Id"
                @ResultCombo="ValueResultDoreMali"
                :rownumintable="3"
                :queryString="{ id: $session.get('UserInfo').tblShobeId }"
                :action="'TblCombo/GetDoreMali'"
                :method="'GET'"
                :idinput="'TblDoreId'"
                :keyItem="'TblDoreId'"
                :disabled="false"
              >
              </SearchableCombo>
              <!-- <combo :IsDefault="false" :IdEl="''" @ValueResult="ValueResultDoreMali" :IsDisabled="true" :IsLoad="true" :ActionUrl="'GetDoreMali'" :Params="$session.get('UserInfo').tblShobeId" :Op_TextDefult="'دوره مالی را انتخاب کنید'"></combo> -->
            </div>
            <div class="col-md-2 col-12">
              <small>تاریخ سند</small>
              <date-picker :disabled="editComputed" color="dimgray" v-model="DataAxiosSanadRizNew.ArryfildValue.TarixSanad"></date-picker>
              <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
            </div>
            <div class="col-md-6 col-12">
              <small>شرح سند </small>
              <textarea ref="SharhSanad" class="form-control" :disabled="editComputed" id="SharhSanad" placeholder="شرح سند" v-model="DataAxiosSanadRizNew.ArryfildValue.SharhSanad"></textarea>
            </div>
            <!-- <div class="col-md-3 mt-5">
              <button class="btn btn-outline-danger" @click="TestStimul">نمایش سند حسابداری</button>
            </div> -->
            <!-- <div class="col-md-4 col-12 mt-3 row">

                <div class="col-6 pt-4 mt-3">
                  <input type="checkbox" id="radifha">
                  <label class="mr-2" for="radifha">تجمیع حساب/تسهیلات</label>
                </div>
              </div> -->
          </div>
        </div>
        <div class="col-12 mt-4 w-100">
          <SanadGrid v-if="$store.state.renderComponent" @sabtnashode="changeSanadStatus" :sabteDaemiSanad="sabtKardanMovaghat" :cols="columns" :edit="editgrid" :rowsProp="rows"></SanadGrid>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import SanadGrid from '@/components/BnpCash/SanadComponents/SanadGrid.vue'
// import Card from '../../Tools/Card.vue'
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
  data() {
    return {
      loadingRender: false,
      AccessBtn: false,
      editgrid: true,
      editable: true,
      DataAxois: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: this.$session.get('UserInfo').tblUserId,
          FormName: 'frmSanadRizNew',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: 'Get',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetSnadMovaghat: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'SanadRizNew/b_AddSanadMovaghat',
        Token: this.$session.get('Token'),
      },
      DataAxiosDelete: {
        ArryfildValue: '',
        Method: 'Delete',
        Action: 'SanadRizNew',
        Token: this.$session.get('Token'),
      },
      Sweet: ['خروج و از بین رفتن اطلاعات', 'سند موقت ثبت نشده است آیا مایل به خروج هستید؟', 'warning', false],
      DataAxoisColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: this.$session.get('UserInfo').tblUserId,
          FormName: 'frmSanadRizNew',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataAxiosSanadRizNew: {
        ArryfildValue: {},
      },
      columns: [],
      rows: [],
      IsSanadMovaghat: false,
      sabtnashode: true,
      sabtKardanMovaghat: true,
    }
  },
  components: {
    // Card,
    SanadGrid,
    datePicker: VuePersianDatetimePicker,
    Card,
    SearchableCombo,
  },
  computed: {
    editComputed() {
      return this.editable
    },
  },
  mounted() {
    try {
      this.$refs.SharhSanad.focus()
      this.columns.unshift({
        id: 13730415,
        name: 'SarfaslCombo',
        visibility: true,
        width: 181,
        indexCol: 0,
        label: 'سرفصل',
      })

      this.DataAxios_GetSnadMovaghat.ArryfildValue = JSON.parse(JSON.stringify(this.$store.state.SanadRizNew.Data[0]))
      if (this.$route.params.Status != 'Edit' && this.$route.params.Status != 'View') {
        this.DataAxios_GetSnadMovaghat.ArryfildValue.TblDoreId = this.$store.state.DoreMaliData[0].Id
        this.DataAxiosSanadRizNew.ArryfildValue = this.$store.state.SanadRizNew.Data[0]
        this.DataAxiosSanadRizNew.ArryfildValue.TarixSanad = this.$store.state.JalaliDate
        this.$PostData(this.DataAxios_GetSnadMovaghat).then((result) => {
          this.DataAxiosSanadRizNew.ArryfildValue.ShomareSanad = result.ShomareSanad
          this.$store.state.SanadRizNew.Data[0].ShomareSanad = result.ShomareSanad
          this.DataAxiosSanadRizNew.ArryfildValue.SharhSanad = result.SharhSanad
          this.DataAxiosSanadRizNew.ArryfildValue.Id = result.ReturnId
          this.$store.state.SanadRizNew.DataAdd.tblSanadId = result.ReturnId
          this.$store.state.renderComponent = true
        })
      } else {
        this.DataAxiosSanadRizNew.ArryfildValue = this.DataAxois
      }
    } catch (error) {}
  },
  methods: {
    // TestStimul() {
    //   this.$store.state.columns = [
    //     {
    //       id: 55,
    //       name: 'Radif',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'ردیف',
    //     },
    //     {
    //       id: 1,
    //       name: 'SharhSarfaslKol',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'سرفصل کل',
    //     },
    //     {
    //       id: 10,
    //       name: 'SharhSarfaslJoze',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'سرفصل جزء',
    //     },
    //     {
    //       id: 25,
    //       name: 'SharhSarfaslMoein',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'سرفصل معین',
    //     },

    //     {
    //       id: 4,
    //       name: 'SharhSanadRiz',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'شرح',
    //     },
    //     {
    //       id: 5,
    //       name: 'Bedeh',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'بدهکار',
    //     },
    //     {
    //       id: 6,
    //       name: 'Bestan',
    //       visibility: true,
    //       width: 181,
    //       indexCol: 0,
    //       label: 'بستانکار',
    //     },
    //     //  {
    //     //   id: 2,
    //     //   name: "SharhSarfaslJoze",
    //     //   visibility: true,
    //     //   width: 181,
    //     //   indexCol: 0,
    //     //   label: "سرفصل جزء",
    //     // },
    //   ]
    //   this.$store.state.rows = this.rows
    //   this.$router.push({
    //     name: 'PrintSanad',
    //   })
    // },
    ValueResultDoreMali(val) {
      this.DataAxiosSanadRizNew.ArryfildValue.TblDoreId = val == null ? 0 : val.id
    },
    refresh() {
      this.$store.state.rendercomponent = false
      this.$store.state.rendercomponent = true
    },
    getGridCol() {},
    Back() {
      this.$router.go(-1)
    },
    changeSanadStatus(value) {
      this.sabtnashode = value
    },
  },
  created() {
    if (this.$route.params.Status == 'View') {
      this.$store.state.rendercomponent = true
      this.columns = this.$NewGridColumns(this.DataAxoisColumns, true, false, false, true)
      this.$store.state.columns = this.columns
    } else {
      this.editgrid = false
      this.columns = [
        {
          id: 13730417,
          name: 'SharhCodeSarfaslJoze',
          visibility: true,
          width: 181,
          indexCol: 0,
          label: 'حساب جزء',
        },
        {
          id: 137304156,
          name: 'HesabJoze',
          visibility: true,
          width: 181,
          indexCol: 0,
          label: 'قسط',
        },
        {
          id: 13730416,
          name: 'SharhSanadRiz',
          visibility: true,
          width: 181,
          indexCol: 0,
          label: 'شرح',
        },
        {
          id: 13730420,
          name: 'FishNoRahgiri',
          visibility: true,
          width: 181,
          indexCol: 0,
          label: 'شماره فیش',
        },
        {
          id: 13730418,
          name: 'Bedeh',
          visibility: true,
          width: 181,
          indexCol: 0,
          label: 'بدهکار',
        },
        {
          id: 13730419,
          name: 'Bestan',
          visibility: true,
          width: 181,
          indexCol: 0,
          label: 'بستانکار',
        },
      ]
      this.$store.state.columns = this.columns
    }
    if (this.$route.params.Status == 'Edit') {
      this.editable = false
    }
    if (this.$route.params.Status == undefined) {
      this.IsSanadMovaghat = true
      this.editable = false
      this.DataAxiosSanadRizNew.ArryfildValue.TarixSanad = this.$store.state.JalaliDate
    }
    if (this.$route.params.Status == 'View' || this.$route.params.Status == 'Edit') {
      this.AccessBtn = true
      this.DataAxois = JSON.parse(JSON.stringify(this.$store.state.SanadRizNew.EditData.sanad))
      this.DataAxios_GetData.Action = this.$route.name + '/Index?id=' + this.DataAxois.Id
      this.DataAxios_GetData.method = 'Get'
      this.DataAxios_GetData.ArryfildValue = null
      var temp_rows
      this.loadingRender = true
      this.$PostData(this.DataAxios_GetData)
        .then((result) => {
          temp_rows = result
        })
        .finally(() => {
          this.rows = temp_rows
          this.$store.state.renderComponent = false
          this.$nextTick(() => {
            this.$store.state.renderComponent = true
            this.loadingRender = false
          })
        })
    } else {
      this.rows = []
    }
  },
  updated() {
    this.columns.forEach((element) => {
      if (['SharhSarfaslKol', 'SharhSarfaslGoroh', 'SharhSarfaslMoein'].includes(element.name)) {
        element.visibility = false
      }
    })

    // console.log("COLUMNS", this.columns);
  },
  beforeDestroy() {
    if (!(this.$route.params.status == 'View' && this.$route.params.status == 'Edit') && this.sabtnashode == true) {
      if (this.rows.length > 0) {
        this.sabtKardanMovaghat = true
      }
    }
    //   if(this.IsSanadMovaghat){
    //     this.DataAxiosDelete.ArryfildValue={id:this.DataAxiosSanadRizNew.ArryfildValue.Id}
    //     this.$DeleteDataSanadMovaghat(this.DataAxiosDelete,this.Sweet)}
    // }
  },
}
</script>

<style scoped></style>
